<template>
  <v-list
    dense
    nav
    class="py-0"
  >
    <v-list-item two-line>
      <v-list-item-avatar>
        <img src="user.png">
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{userName}}</v-list-item-title>
        <v-list-item-subtitle>{{userCodigo}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item
      v-for="(item,index) in menu"
      :key="index"
      link
      @click="redirect(item.route)"
    >
      <v-list-item-avatar>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters} from 'vuex'

export default {
  name: 'leftMenu',
  props:['menu'],
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "userName",
      "userCodigo",
      "userId"
    ]),
  },
  data () {
    return {
      drawer: false,
      color: 'primary',
      avatar: 'user.png'
    }
  },
  created(){
  //  this. avatar = `${this.httpURL}/usuario/imagen/${this.userId}`;
  },
  methods:{
    redirect(route){
      if( this.$route.path != route )
        this.$router.push(route);
      else
        this.$emit('cerrarMenu');
    }
  }
}
</script>